import { css, keyframes } from '@emotion/react';

const shineBox = keyframes`
  to {
    background-position: 200% center;
  }
`;

export const helperLoadingBox = (bgColor: string) => css`
  position: relative;

  &:before {
    content: '';
    pointer-events: none;
    position: absolute;
    z-index: 20;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: linear-gradient(
      to left,
      ${bgColor},
      rgba(255, 255, 255, 0.0001) 50%,
      ${bgColor}
    ); /* 0.0001 for safary */
    background-size: 200% auto;
    animation: ${shineBox} 1s linear infinite;
  }
`;
